import React from 'react';
import AdminSidebar from "../../admin/common/components/AdminSidebar";

interface AdminLayoutProps {
  children: React.ReactNode;
  mainId?: string;
  className?: string;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  children,
  mainId,
  className = ''
}) => {
  return (
    <div id={mainId} className={`flex ${className}`}>
      <AdminSidebar/>
      <section id="main-content" className="flex-1 p-8">
        {/* Breadcrumbs */}
        {children}
      </section>
    </div>
);
};

export default AdminLayout;
